{
	"title": "Calendar",
	"subtitle": "Lessons, exams and review schedule",
	"views": {
		"day": "Day",
		"week": "Week",
		"month": "Month",
		"agenda": "Agenda"
	},
	"nav": {
		"prev": "Previous",
		"next": "Next",
		"today": "Today"
	},
	"events": {
		"addEvent": "Add event",
		"newEvent": "New event",
		"editEvent": "Edit event",
		"studySession": "Study session",
		"exam": "Exam",
		"deadline": "Deadline",
		"lecture": "Lecture",
		"reminder": "Reminder",
		"moreCount": "+{count} more",
		"dayCount": "{count, plural, one {# event} other {# events}}",
		"countOne": "{count} event",
		"countFew": "{count} events",
		"countMany": "{count} events"
	},
	"types": {
		"lesson": "Lesson",
		"exam": "Exam",
		"review": "Review",
		"custom": "Custom"
	},
	"fields": {
		"title": "Title",
		"titlePlaceholder": "e.g. AP Biology Exam",
		"description": "Description",
		"descriptionPlaceholder": "Optional",
		"type": "Type",
		"allDay": "All day",
		"start": "Starts",
		"end": "Ends",
		"timezone": "Timezone",
		"location": "Location",
		"locationPlaceholder": "e.g. Room 201",
		"recurrence": "Repeat",
		"reminder": "Reminder",
		"examPreset": "Exam preset"
	},
	"recurrence": {
		"none": "Does not repeat",
		"daily": "Daily",
		"weekly": "Weekly",
		"monthly": "Monthly",
		"yearly": "Yearly",
		"weekdays": "Weekdays"
	},
	"reminders": {
		"label": "Reminders",
		"none": "No reminder",
		"min5": "5 minutes before",
		"min10": "10 minutes before",
		"min30": "30 minutes before",
		"hour1": "1 hour before",
		"hour2": "2 hours before",
		"day1": "1 day before",
		"minutesBefore": "{count} min before",
		"hoursBefore": "{count} h before",
		"daysBefore": "{count} d before"
	},
	"today": "Today",
	"thisWeek": "This week",
	"noEvents": "No events today",
	"examIn": "Exam in {days} days",
	"weekRange": "{from} — {to}",
	"month": {
		"header": "{month} {year}",
		"empty": "Nothing scheduled this month",
		"addOne": "Add event"
	},
	"week": {
		"now": "Now",
		"empty": "Nothing scheduled this week",
		"allDay": "All day"
	},
	"day": {
		"empty": "Nothing scheduled today"
	},
	"dialog": {
		"create": "New event",
		"edit": "Edit event",
		"view": "Event",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"deleteConfirm": "Delete event?",
		"deleteConfirmDescription": "The event will move to trash for 30 days.",
		"validation": {
			"titleRequired": "Title is required",
			"endAfterStart": "End must be after start"
		}
	},
	"errors": {
		"loadFailed": "Failed to load calendar",
		"retry": "Retry"
	},
	"dayNamesShort": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
	"dayNamesLong": [
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
		"Sunday"
	],
	"monthNames": [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	"examPicker": {
		"title": "Exam date",
		"set": "Set date",
		"edit": "Edit date"
	}
}
